import React, { useEffect, useState } from "react";
import { Radio, ExternalLink, Calendar } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Badge } from "@/components/common";
import { Button } from "@/components/ui/button";

export default function LiveClasses() {
  const [classes, setClasses] = useState([]);
  useEffect(() => { api.get("/my/live-classes").then(({ data }) => setClasses(data)); }, []);
  return (
    <div data-testid="live-classes-page">
      <PageHeader title="Live Classes" subtitle="Join your upcoming interactive sessions" />
      {classes.length === 0 ? <EmptyState icon={Radio} title="No live classes scheduled" subtitle="Live classes from your enrolled courses will appear here." /> : (
        <div className="space-y-3">
          {classes.map((l) => (
            <div key={l.id} className="bg-white border border-border rounded-lg p-5 flex flex-wrap items-center justify-between gap-4" data-testid={`live-${l.id}`}>
              <div className="flex items-center gap-4">
                <div className="h-11 w-11 rounded-lg bg-crimson/10 text-crimson flex items-center justify-center"><Radio size={20} /></div>
                <div>
                  <h3 className="font-semibold text-navy">{l.title}</h3>
                  <p className="text-sm text-muted-foreground flex items-center gap-2"><Calendar size={13} /> {l.date} • {l.start_time} - {l.end_time}</p>
                  {l.subject && <span className="text-xs text-muted-foreground">{l.subject} {l.topic && `› ${l.topic}`}</span>}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Badge tone={l.status === "scheduled" ? "amber" : "gray"}>{l.status}</Badge>
                {l.meeting_url && <a href={l.meeting_url} target="_blank" rel="noreferrer"><Button size="sm" className="viriks-crimson bg-crimson text-white hover:bg-crimson/90">Join Class <ExternalLink size={13} className="ml-1" /></Button></a>}
                {l.recording_url && <a href={l.recording_url} target="_blank" rel="noreferrer"><Button size="sm" variant="outline">Recording</Button></a>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
